import widget from './widget';

export default {
  ...widget,
  styles: {
    tg24: {
      iconsColor: 'c-light',
    },
    entertainment: {
      iconsColor: 'c-light',
    },
    sport: {
      iconsColor: 'c-light',
    },
  },
};
